import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import {
  currentAccountIdVar,
  primaryAccountIdVar,
} from '../../../data/apollo/cache/reactiveVars';

export const Route = createFileRoute('/_authenticated/client/')({
  component: Outlet,
  beforeLoad: ({ location }) => {
    // If we're already on a client route (like /client/TIRCBDemo-1), don't redirect
    if (
      location.pathname.startsWith('/client/') &&
      location.pathname !== '/client/'
    ) {
      return;
    }
    // else check if client account is active
    if (
      currentAccountIdVar() &&
      currentAccountIdVar() !== primaryAccountIdVar()
    ) {
      throw redirect({
        to: '/client/$accountId',
        params: {
          accountId: currentAccountIdVar() as unknown as string,
        },
        replace: true,
      });
    }
    // else revert to dashboard
    throw redirect({
      to: '/',
      replace: true,
    });
  },
});
